import { Fragment, Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { withRouter } from 'react-router-dom';
import * as ImportTypes from 'documents-ui/constants/ImportTypes';
import { getLocationQuery } from 'SalesContentIndexUI/data/utils/router';
import { trackUpload } from 'documents-lib/js/tracking/tracker';
import { UPLOAD_FILE_INDEX } from 'documents-lib/js/tracking/actions';
import { getFileVisibilityKBLink } from 'documents-lib/js/lib/links';
// @ts-expect-error No types available
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { ListItem } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import LocalFileButton from 'documents-ui/components/importButtons/LocalFileButton';
import FileManagerButton from 'documents-ui/components/importButtons/FileManagerButton';
import DropboxButton from 'documents-ui/components/importButtons/DropboxButton';
import GoogleDriveButton from 'documents-ui/components/importButtons/GoogleDriveButton';
import BoxButton from 'documents-ui/components/importButtons/BoxButton';
import { isOwnedByCurrentUser } from 'documents-ui/utils/owner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FILE_MANAGER_WIDTH = 477;
export class DocumentsCreatePanel extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      fileManagerLoaded: false,
      isFileManagerOpen: false,
      FileManager: null,
      fileManagerError: null
    };
    this.getCurrentFolderId = () => {
      const locationQuery = getLocationQuery(this.props.location);
      const folderId = locationQuery.folder;
      return folderId ? parseInt(folderId, 10) : undefined;
    };
    this.closeFileManager = () => {
      this.setState({
        isFileManagerOpen: false
      });
    };
    this.handleFileManagerClick = () => {
      this.setState({
        isFileManagerOpen: true
      });
    };
    this.handleFileManagerImport = file => {
      this.handleImportFile({
        type: ImportTypes.FILE_MANAGER,
        file: {
          name: file.title
        },
        fileManagerFileId: file.id
      });
      this.closeFileManager();
      this.props.onButtonClick();
    };
    this.handleImportFile = importConfig => {
      this.props.importFile(Object.assign({}, importConfig, {
        folderId: this.getCurrentFolderId()
      }));
      trackUpload({
        action: UPLOAD_FILE_INDEX,
        source: importConfig.type
      });
    };
    this.renderFileManager = () => {
      if (!(this.state.isFileManagerOpen && this.state.FileManager)) {
        return null;
      }
      const {
        FileManager
      } = this.state;
      return /*#__PURE__*/_jsx(FileManager, {
        onSelect: this.handleFileManagerImport,
        onClose: this.closeFileManager
      });
    };
  }
  componentDidMount() {
    if (this.props.loadFileManager) {
      this.props.loadFileManager().then(entry => {
        this.setState({
          fileManagerLoaded: true,
          FileManager: entry.default,
          fileManagerError: null
        });
      }).catch(err => {
        this.setState({
          fileManagerError: err
        });
        throw err;
      });
    }
  }
  render() {
    var _documentMetadata$get, _documentMetadata$get2;
    const {
      documentMetadata,
      isReupload,
      onButtonClick,
      handleLocalFileImport
    } = this.props;
    const showEditWarnings = isReupload && !isOwnedByCurrentUser((_documentMetadata$get = documentMetadata === null || documentMetadata === void 0 ? void 0 : documentMetadata.get('userId')) !== null && _documentMetadata$get !== void 0 ? _documentMetadata$get : null);
    const owner = (_documentMetadata$get2 = documentMetadata === null || documentMetadata === void 0 ? void 0 : documentMetadata.get('user')) !== null && _documentMetadata$get2 !== void 0 ? _documentMetadata$get2 : null;
    const editWarningProps = {
      showEditWarnings,
      owner
    };
    const importButtonProps = {
      editWarningProps,
      importFile: this.handleImportFile,
      useMultiSelect: !isReupload
    };
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs(Panel, {
        "data-test-id": "documents-create-panel",
        width: FILE_MANAGER_WIDTH,
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          "data-test-id": "documents-create-panel-close-button",
          onClick: onButtonClick
        }), /*#__PURE__*/_jsx(PanelHeader, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "h2",
            color: "text-core-on-fill-default",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "headerButtons.createButton.uploadDocument"
            })
          })
        }), /*#__PURE__*/_jsxs(PanelBody, {
          children: [/*#__PURE__*/_jsx(PanelSection, {
            children: /*#__PURE__*/_jsx(Alert, {
              "data-test-id": "documents-public-alert",
              type: "warning",
              children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                message: "headerButtons.createPanel.publicAlert.body_jsx",
                options: {
                  linkProps: {
                    url: getFileVisibilityKBLink()
                  }
                },
                elements: {
                  strong: 'strong',
                  Link: KnowledgeBaseButton
                }
              })
            })
          }), /*#__PURE__*/_jsxs(PanelSection, {
            paddingBlockStart: "100",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h5",
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "headerButtons.createPanel.chooseFrom"
              })
            }), /*#__PURE__*/_jsxs(List, {
              children: [/*#__PURE__*/_jsx(ListItem, {
                marginBlockEnd: "200",
                children: /*#__PURE__*/_jsx(LocalFileButton, {
                  onClick: handleLocalFileImport,
                  editWarningConfig: editWarningProps
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                marginBlockEnd: "200",
                children: /*#__PURE__*/_jsx(FileManagerButton, {
                  isFileManagerLoading: !this.state.fileManagerLoaded,
                  fileManagerError: !!this.state.fileManagerError,
                  onClick: this.handleFileManagerClick,
                  editWarningConfig: editWarningProps
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                marginBlockEnd: "200",
                children: /*#__PURE__*/_jsx(DropboxButton, Object.assign({}, importButtonProps, {
                  editWarningConfig: editWarningProps,
                  onClick: onButtonClick
                }))
              }), /*#__PURE__*/_jsx(ListItem, {
                marginBlockEnd: "200",
                children: /*#__PURE__*/_jsx(GoogleDriveButton, Object.assign({}, importButtonProps, {
                  editWarningConfig: editWarningProps,
                  onClick: onButtonClick
                }))
              }), /*#__PURE__*/_jsx(ListItem, {
                marginBlockEnd: "200",
                children: /*#__PURE__*/_jsx(BoxButton, Object.assign({}, importButtonProps, {
                  editWarningConfig: editWarningProps,
                  onClick: onButtonClick
                }))
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(PanelFooter, {
          children: /*#__PURE__*/_jsx(Button, {
            use: "secondary",
            onClick: onButtonClick,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "headerButtons.createPanel.buttons.cancel"
            })
          })
        })]
      }), this.renderFileManager()]
    });
  }
}
DocumentsCreatePanel.defaultProps = {
  isReupload: false,
  loadFileManager: () => import( /* webpackChunkName: "file-manager" */'../FileManager.tsx')
};
export default withRouter(DocumentsCreatePanel);